import React from 'react';
import Card from '../../../../components/Card/CardNew';

function SupportConfirmation() {
  return (
    <Card className={'mt-3'}>
      <div className={'B1'}>
        Ваше сообщение принято к рассмотрению. По результатам рассмотрения информация о сроках
        уплаты налогов и представления отчетности для вас и вашего бизнеса будут автоматически
        актуализированы.
      </div>
    </Card>
  );
}

export default SupportConfirmation;
